import React from 'react'

export default function RedCrossBannerInstitute() {
    return (
        <>
            <div class="container">
                <div class="icrspart">
                    <img src="../img/2ndimage.jpg" alt="icrs image" class=".img-responsive" width={"100%"} />
                </div>
                <div class="icrspart">
                    <img src="../img/3rdimage.jpg" alt="icrs image" class=".img-responsive" width={"100%"} />
                </div>
                <div class="icrspart">
                    <img src="../img/1stimage.jpg" alt="icrs image" class=".img-responsive" width={"100%"} />
                </div>

            </div>
        </>
    )
}
